//---------------------------------------------------
//  Nom du fichier : Conversation.js 
//
//  Description: Component qui englobe la page conversation 
//               et la logique du chat
//               Permet d'envoyer des messages et d'en recevoir en live
//               
//  Auteur: Alek Del Balso
//---------------------------------------------------

import './conversation.css';
import { useState, useEffect, useRef } from "react";
import {callAPI} from './callAPI.js'
import { useParams, useNavigate } from "react-router-dom";
import Recherche from './Recherche.js';
import { useTranslation } from "react-i18next";

function Chat({info, myImage, ws, newMessages, setNewMessages, setUsers}) {
    const { t } = useTranslation();
    const [messages, setMessages] = useState([])
    const [text, setText] = useState("")
    const [loading, setLoading] = useState(false)
    const divRef = useRef(null);
    

    useEffect(() => {
        const remainingMessages = newMessages.filter(msg => msg.sender !== info.id);
        if (remainingMessages.length !== newMessages.length) {
            setNewMessages(remainingMessages)
        }

        const form = new FormData()
        form.append('type', 'get_messages')
        form.append('other_id', info.id)
    
        callAPI("read", form)
        .then((data) => {
          setMessages(data.result ?? [])
          divRef.current.scrollTop = divRef.current.scrollHeight;
        })
        .catch((error) => {
            console.error("API call failed:", error);
        });

        //new messages notif
        setUsers(prevUsers => 
            prevUsers.map(user =>
                user.id === info.id ? { ...user, unread_count: 0 } : user
            ) 
        )
    },[info])

    useEffect(() => {

        let messagesToAdd = [];
    
        newMessages.forEach(msg => {
            if (msg.sender === info.id) {
                messagesToAdd.push({
                    my: msg.my,
                    id: msg.id,
                    receiver: msg.receiver,
                    sender: msg.sender,
                    created_at: msg.created_at,
                    message: msg.message,
                    user_id: msg.user_id
                });
            }
        });
 
        if (messagesToAdd.length > 0) {
            setMessages(prevMessages => [...prevMessages, ...messagesToAdd]);
        }
    
        const remainingMessages = newMessages.filter(msg => msg.sender !== info.id);
        if (remainingMessages.length !== newMessages.length) {
            setNewMessages(remainingMessages);
        }

        divRef.current.scrollTop = divRef.current.scrollHeight;

        const form = new FormData()
        form.append('type', 'remove_unread_chat')
        form.append('other_id', info.id)

        callAPI("write", form)
        .then((data) => {
            })
        .catch((error) => {
            console.error("API call failed:", error);
        });
    },[newMessages])

    const send_message = () => {
        if(text == null || text == "" || loading) return;
        setLoading(true)

        let send_text = text
        setText("")

        const form = new FormData()
        form.append('type', 'send_message')
        form.append('message', send_text)
        form.append('receiver_id', info.id)

        const now = new Date();
        const utcTimestamp = now.toISOString().slice(0, 19).replace('T', ' ');

        //garde ajour le dernier message
        setUsers(prevUsers =>
            prevUsers.map(user =>
                user.id === info.id
                ? { ...user, last_message: utcTimestamp }
                : user
            )
        );

        callAPI("write", form)
        .then((data) => {
          setMessages((prevMessages) => [...prevMessages, {
            my:true, 
            id:data.status.id, 
            receiver:info.id, 
            sender:data.user_id,
            created_at:utcTimestamp, 
            message:send_text, 
            user_id:data.status.id}])

            if (ws && ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify({ 
                    type: "message", 
                    my:false,
                    fromAdmin:0, 
                    to:info.id,
                    id:data.status.id, 
                    receiver:info.id, 
                    sender:data.user_id,
                    created_at:utcTimestamp, 
                    message:send_text, 
                    user_id:data.status.id
                }));
            }

            setUsers(prevUsers =>
                [...prevUsers].sort((a, b) => {
                    const dateA = a.last_message ? new Date(a.last_message) : null;
                    const dateB = b.last_message ? new Date(b.last_message) : null;

                    if (!dateA && !dateB) return 0;           // Les deux sont null → égalité
                    if (!dateA) return 1;                     // a est null → va après b
                    if (!dateB) return -1;                    // b est null → b va après a

                    return dateB - dateA;                     // Sinon, tri normal (du plus récent au plus vieux)
                })
            );

            setLoading(false)
            })
        .catch((error) => {
            console.error("API call failed:", error);
        });
    }

    useEffect(() => {
        if(divRef.current)
            divRef.current.scrollTop = divRef.current.scrollHeight;
    }, [messages,newMessages])

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            send_message();
            setText(""); 
            e.preventDefault();  
        } else if (e.key === "Enter" && e.shiftKey) {
            setText(prevText => prevText + "\n");
            e.preventDefault(); 
        }
    };


    const navigate = useNavigate();
    let id = -1;
    return (<>
        <div className='chatArea' ref={divRef}>
            <div className='convo_info' onClick={()=>navigate(`/profil/${info.id}/${info.id}`)}>
                <span className="material-symbols-outlined person_icon">person</span>
                {info.name}
            </div>
            {messages.length > 0 ? (
                    messages.map(message => {
                        if(message.id == id)return
                        id = message.id
                        const localDate = new Date(message.created_at + 'Z');
                        const formattedTime = localDate.toLocaleTimeString([], { 
                            hour: '2-digit', 
                            minute: '2-digit',
                            hour12: false  // Set to false to use 24-hour format
                        });
                        
                        const style = message.fromAdmin ? "fullMessage AdminMessage" : (message.my ? 'fullMessage receiver' : 'fullMessage')
                        const own = "singleMessage " + (message.fromAdmin ? '' : (message.my ? ' myMsg' : 'otherMsg'))
                        return(
                        <div className={style} key={message.id}>
                            <div className={own}>
                                {!message.fromAdmin &&  
                                    <div className='messageUser'>
                                        <button onClick={() => {navigate(`/profil/${message.user_id}/${info.id}`)}} 
                                        className='messageImage' 
                                        style={message.my ? {backgroundImage: myImage !== null ? `url('https://rockstoclimb.com/uploads/profiles/${myImage}')` : 'url("/Images/defImage.png")'} : {backgroundImage: info.file_path !== null ? `url('https://rockstoclimb.com/uploads/profiles/${info.file_path}')` : 'url("/Images/defImage.png")'}}  >
                                        </button>
                                    </div>
                                }
                                <div className='messageText'>{message.message}</div>
                                <div className='messageTime'>{formattedTime}</div>
                            </div>
                        </div>
                        )
                    })
                ): (
                    <p style={{color:'black', textAlign:'center'}}>{t('convo_no_messages')}</p>
                )}
        </div>

        <div className='bottomAreaConvo'>
            <textarea 
                maxLength={255} 
                name="message" 
                value={text}
                onChange={e => setText(e.target.value)}
                onKeyDown={handleKeyDown}
                onSubmit={send_message}
                className='inputChat'
                placeholder={t('convo_send')}
                wrap='soft'/>
            <span className="material-symbols-outlined sendChat" onClick={send_message}>send</span>
        </div>
    </>)
  }
  









  

  function Conversation({ws, newMessages, setNewMessages}) {

    const { t } = useTranslation();
    const [users, setUsers] = useState([])
    const [currentUser, setCurrentUser] = useState(null)
    const [myFile, setMyFile] = useState(null)
    const [showConvo, setShowConvo] = useState(false)
    const navigate = useNavigate();
    let { user_id } = useParams();
    let convoRef = useRef(null)
    let chatRef = useRef(null)

    useEffect(() => {
        if(localStorage.getItem("user_id") == -1)
            navigate("/")

        setNewMessages([])

        let form = new FormData()
        form.append('type', 'get_user_connection')
        callAPI("read", form)
        .then((data) => {
            setUsers(data.result)
            setMyFile(data.imagePath)
            const userExists = data.result.some(user => user.id == user_id);
            if(user_id != localStorage.getItem("user_id")){
                if(!userExists) //nouvelle convo
                    get_user(user_id)
                else{
                    let entry = data.result.find(item => item.id === user_id);
                    setCurrentUser({id:user_id, file_path:entry.file_path, name:entry.username})
                }
            }   
        })
        .catch((error) => {
            console.error("API call failed:", error);
        });
    },[])

    const get_user = (user_id, open = true) => {
        let form = new FormData()
        form.append('type', 'get_username')
        form.append('user_id', user_id)

        callAPI("read", form)
        .then((data) => {
            if(data.result.username != undefined){
                setUsers((prevUsers) => {
                    let newUser = { id: user_id, username: data.result.username, file_path:data.result.file_path, unread_count:0, unread_count_new: (open ? 0 : 1) }
                    if(prevUsers == undefined) return [newUser]
                    if (!prevUsers.some(user => user.id === user_id)) {
                        return [newUser, ...prevUsers];
                    }
                    return prevUsers; 
                });
                if(open)
                    setCurrentUser({id:user_id, file_path:data.result.file_path, name:data.result.username})
            }
        })
        .catch((error) => {
            console.error("API call failed:", error);
        });
    }


    useEffect(() => {
        newMessages.forEach(message => {
            if(message.sender == localStorage.getItem("user_id")) return

            //new convo
            const userExists = users.some(user => user.id == message.sender);
            if(!userExists){
                get_user(message.sender, false)
            }            
        });
        setUsers(prevUsers => {
            // Étape 1 : reset unread_count_new
            let updatedUsers = prevUsers.map(user => ({ ...user, unread_count_new: 0 }));
          
            // Étape 2 : pour chaque message, mettre à jour les users correspondants
            newMessages.forEach(msg => {
              updatedUsers = updatedUsers.map(user => {
                if (user.id === msg.sender) {
                  const currentLast = user.last_message ? new Date(user.last_message) : null;
                  const newMsgDate = new Date(msg.created_at);
          
                  return {
                    ...user,
                    unread_count_new: user.unread_count_new + 1,
                    last_message:
                      !currentLast || newMsgDate > currentLast
                        ? msg.created_at
                        : user.last_message,
                  };
                } else {
                  return user;
                }
              });
            });
          
            // Étape 3 : trier selon la date de last_message
            updatedUsers.sort((a, b) => {
              const dateA = a.last_message ? new Date(a.last_message) : null;
              const dateB = b.last_message ? new Date(b.last_message) : null;
          
              if (!dateA && !dateB) return 0;
              if (!dateA) return 1;
              if (!dateB) return -1;
          
              return dateB - dateA; // Plus récent d'abord
            });
          
            return updatedUsers;
          });
    },[newMessages])


    const openConvo = () => {
        if(!convoRef.current || !chatRef.current) return
        if(showConvo){
            convoRef.current.classList.add("openingConvo");
            chatRef.current.classList.add("openingConvo");
        }
        else{
            convoRef.current.classList.remove("openingConvo");
            chatRef.current.classList.remove("openingConvo");
        }

        setShowConvo(!showConvo)
    }

    return(<>
    <div className='convo_container'>
        <div className='conversation openingConvo' ref={convoRef}>
            <div className='inner_conversation'>
                <div className='rechercher_container_convo'>
                    <Recherche toChat={true} className="rechercheConvo"/>
                </div>
                <div className='allConvo'>
                    {users && users.length > 0 ? (
                        users.map(user => {
                        let formattedTime = ''
                        if(user.last_message){
                            const localDate = new Date(user.last_message + 'Z');
                            formattedTime = localDate.toLocaleTimeString([], { 
                                hour: '2-digit', 
                                minute: '2-digit',
                                hour12: false  // Set to false to use 24-hour format
                            });
                        }
                        return(
                            <button className='oneConvo' onClick={() => {setCurrentUser({id:user.id, file_path:user.file_path, name:user.username}); openConvo()}} key={user.id}>
                                {user.username} 
                                <div className='last_message'>
                                    {formattedTime}
                                </div>
                                <div className='userImageChat' style={{backgroundImage: user.file_path !== null ? `url('https://rockstoclimb.com/uploads/profiles/${user.file_path}')` : 'url("/Images/defImage.png")'}} ></div> 
                                {user.unread_count + user.unread_count_new > 0  ? <div className='newMessagesNotif'>{user.unread_count + user.unread_count_new > 9 ? "9+" : user.unread_count + user.unread_count_new}</div>: ""}
                            </button>
                        )
                        })
                    ): (
                        <p style={{color:'white', textAlign:'center'}}>{t('convo_no')}</p>
                    )}
                </div>
            </div>
        </div>
        <div className='convo_btns'>
            <span style={{
                fontVariationSettings: `'FILL' ${showConvo ? 0 : 1}, 'wght' 250, 'GRAD' 200, 'opsz' 24`,
                transition: "font-variation-settings 0.2s ease"
            }} className='material-symbols-outlined openBtn' onClick={openConvo}>chat</span>
            <span className='material-symbols-outlined' id="quitChat" onClick={() => navigate("/")}>close</span>
        </div>
        <div className='chat openingConvo' ref={chatRef}>
            {currentUser != null ? <Chat info={currentUser} myImage={myFile} ws={ws} newMessages={newMessages} setNewMessages={setNewMessages} setUsers={setUsers}/> : <div className='noConvo'> {t('convo_no_chose')}</div>} 
        </div>
    </div>
    </>)

  }
  export default Conversation;